import { render } from "./AnnotatedCandleChart.vue?vue&type=template&id=f55cc42a&scoped=true"
import script from "./AnnotatedCandleChart.vue?vue&type=script&lang=js"
export * from "./AnnotatedCandleChart.vue?vue&type=script&lang=js"

import "./AnnotatedCandleChart.vue?vue&type=style&index=0&id=f55cc42a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f55cc42a"]])

export default __exports__